import React from "react";

export default function CurrentClassEmptyState() {
  return (
    <div className="studio-empty-state">
      <p>Class details will appear when an event is active.</p>
    </div>
  );
}
